import { useContext, useEffect, useState } from 'react';

/** @format */
import { Link } from 'react-router-dom';

import Logo from '../../Assets/Images/logo.jpg';
import User from '../../Assets/Images/default-avatar.png';
import { EventContext } from '../../Contexts/EventContext';
import { error } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { checkLogin } from '../../Shared/hooks/authenticate';
import { removeStoredAuthToken } from '../../Shared/utils/authToken';
import { number_format } from '../../Shared/utils/helper';

const Header = ({ headerFixed }) => {
  const eventContext = useContext(EventContext);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getUser = async () => {
      setLoading(true);
      await useApi.get(
        '/user',
        {},
        (res) => {
          eventContext.authUser = res.data.data;
          setLoading(false);
        },
        (err) => {
          setLoading(false);
          error('هنگام دریافت اطلاعات پروفایل خطایی رخ داده است');
        },
      );
    };
    if (checkLogin()) {
      getUser();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openProfileMenu = () => {
    let backDark = document.getElementById('dark-back');
    let profileMenu = document.getElementById('header-menu-profile');

    backDark.classList.remove('d-none');
    backDark.classList.add('d-flex');
    profileMenu.classList.remove('d-none');
    profileMenu.classList.add('d-flex');
  };
  const closeProfileMenu = () => {
    let backDark = document.getElementById('dark-back');
    let profileMenu = document.getElementById('header-menu-profile');

    profileMenu.classList.add('d-none');
    profileMenu.classList.remove('d-flex');
    backDark.classList.add('d-none');
    backDark.classList.remove('d-flex');
  };

  return (
    <header className={`w-100 ${headerFixed ? 'sticky-top' : ''}`}>
      <section className='container-fluid '>
        <div className='row'>
          <div className='col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4'>
            <Link
              to='/'
              className='w-25 d-none d-sm-none d-md-flex d-lg-flex d-xl-flex flex-row justify-content-start'
            >
              <img src={Logo} alt='logo' className='mt-2 w-100' style={{borderRadius: '1rem'}} />
            </Link>
            <Link
              to='/'
              className='d-flex d-sm-flex d-md-none h-100 d-lg-none d-xl-none flex-row justify-content-start'
            >
              <img src={Logo} alt='logo' className='mt-2 w-100' style={{borderRadius: '1rem'}}/>
            </Link>
          </div>
          <div className='col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 justify-content-center align-items-center mt-3 text-center'>
            <span className='f-14 font-weight-bold text-center text-break mt-3'>
              سامانه مسابقات فدراسیون بیلیارد
            </span>
          </div>
          {loading ? null : (
            <div className='d-flex d-md-flex d-lg-flex d-xl-flex col-md-4 col-lg-4 col-xl-4 justify-content-end'>
              {checkLogin() ? (
                <>
                  <div className='d-flex flex-row justify-content-end c-pointer align-items-center'>
                    <div
                      className='d-flex flex-row justify-content-end align-items-center c-pointer mt-2'
                      onClick={openProfileMenu}
                    >
                      <img
                        style={{
                          width: '60px',
                          height: '60px',
                        }}
                        src={
                          eventContext?.authUser?.personnel_image
                            ? eventContext.authUser.personnel_image
                            : User
                        }
                        alt='user'
                        className='img-thumbnail rounded-circle rounded-pill'
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = User;
                        }}
                      />
                      <strong className="d-inline-block px-1 f-14">پروفایل</strong>
                      <i className='fad fa-angle-down f-24 text-purple mx-3 align-self-center'></i>
                    </div>

                    <div
                      onClick={closeProfileMenu}
                      className='d-none vw-100 vh-100'
                      id='dark-back'
                      style={{
                        position: 'fixed',
                        zIndex: '99',
                        top: '0',
                        right: '0',
                      }}
                    ></div>
                    <div
                      id='header-menu-profile'
                      className='d-none flex-column bg-purple border-dark-mode rounded-1 shadow p-2 position-absolute'
                      style={{
                        width: '246px',
                        top: '55px',
                        left: '15px',
                        zIndex: '9999999',
                        opacity: '1',
                      }}
                    >
                      <div className='d-flex flex-row border-bottom-dark-mode text-center justify-content-center pb-2 p-2'>
                        <i className='fad fa-user'></i>
                        <span className='text-dark-mode f-12 mx-2'>
                          {eventContext.authUser ? (eventContext.authUser.name ?? '') + ' ' + (eventContext.authUser.last_name ?? '') : ''}
                        </span>
                      </div>
                      <div className='d-flex flex-row border-bottom-dark-mode pb-2 p-2'>
                        <span className='text-dark-mode f-12 mx-2 font-weight-bold'>
                          اعتبار :{' '}
                          {number_format(
                            eventContext.authUser?.wallet?.amount ?? 0,
                          )}{' '}
                          ریال
                        </span>
                      </div>
                      <ul className='d-flex flex-column nav m-0 p-0'>
                        <li className='d-flex border-bottom-dark-mode my-1'>
                          <Link to='/' className='w-100 d-flex flex-row py-2 hover-black'>
                            <i className='fad fa-user text-dark-mode f-18'></i>
                            <strong className='text-dark-mode f-12 mx-2'>
                              صفحه اصلی
                            </strong>
                          </Link>
                        </li>

                        <li className='d-flex my-1 border-bottom-dark-mode'>
                          <Link
                            to='/panel'
                            className='w-100 d-flex flex-row py-2 hover-black'
                          >
                            <i className='fad fa-user-cog text-dark-mode f-18'></i>
                            <strong className='text-dark-mode f-12 mx-2'>
                              پنل کاربری
                            </strong>
                          </Link>
                        </li>

                        <li className='d-flex my-1'>
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              removeStoredAuthToken();
                              window.location.href = '/';
                            }}
                            to='#'
                            className='w-100 d-flex flex-row py-2 hover-black'
                          >
                            <i className='fad fa-door-open text-dark-mode f-18'></i>
                            <strong className='text-dark-mode f-12 mx-2'>
                              خروج
                            </strong>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </>
              ) : (
                <div className='d-flex flex-row justify-content-center align-items-center'>
                  <Link to='/login' className='d-flex flex-row btn btn-info'>
                    <span className='text-white mx-2 f-13 mt-1 font-weight-bold'>
                      ورود به سایت
                    </span>
                  </Link>
                  <Link
                    to='/register'
                    className='d-flex flex-row btn btn-info mx-2'
                  >
                    <span className='text-white mx-2 f-13 mt-1 font-weight-bold'>
                      ثبت نام
                    </span>
                  </Link>
                </div>
              )}
            </div>
          )}
        </div>
      </section>
      <div className='w-100 bg-purple p-2 mt-2'>
        <section className='container-fluid'>
          <div className='row'>
            <div className='d-flex flex-row'>
              <ul className='d-flex flex-row nav'>
                <li className=''>
                  <Link className='text-dark-mode hover-black f-14 mx-2' to='/'>
                    صفحه اصلی
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </header>
  );
};
export default Header;
